import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './SearchPanel.html?raw';
import "../../../moreCore/UI/GenericDialog/GenericDialog";
import "../../../moreCore/UI/Toaster_TS/Toaster";
import DateInput from '../../../moreCore/UI/DateInput/DateInput';
import "../../../moreCore/UI/DateInput/DateInput";
import "../../../moreCore/UI/EntityBased/CalendarSearchSelect/CalendarSearchSelect";
import Edit from '../../../moreCore/UI/Edit/Edit';
import FloatingContainer from '../../../moreCore/UI/Floating/FloatingContainer';
import { WebcalendarTypes } from "../../../moreCore/UI/moreCoreCalendar/WebCalendarTypes";



class MainPropertiesSearchPanel extends compose(_WidgetBaseSP) {
    templateString: any = template;
    //// NODES -------------------------------------------------------------START
    private inputDateStart: MdsLax<InstanceType<typeof DateInput>>;
    private search_dateEnd_container: HTMLElement;
    private inputDateEnd: MdsLax<InstanceType<typeof DateInput>>;
    private search_keyword_container: HTMLElement;
    private inputKeyword: MdsLax<InstanceType<typeof Edit>>;
    private search_dateStart_container: HTMLElement;
    private txtMessage: HTMLElement;
    private resultContainer: HTMLElement;
    private messageContainer: HTMLElement;

    private _isFocused: boolean = false;

    //// NODES -------------------------------------------------------------END
    ////PROPS -------------------------------------------------------------STRT
    
    dateMin: Date = null; // Date
    dateMax: Date = null; // Date

    private activeFilterIDs: Array<string> = []; // Array of active string IDs
    private resourceIDs: Array<string> = []; // Array of active string IDs
    private calendarID: string = null;

    ////PROPS -------------------------------------------------------------END
    //// METHODS -------------------------------------------------------------START

    private _setControlDateLimits():void {

        this.inputDateStart.setMinValue(this.dateMin);
        this.inputDateStart.setMaxValue(this.dateMax);

        this.inputDateEnd.setMinValue(this.dateMin);
        this.inputDateEnd.setMaxValue(this.dateMax);

      
    }
  

    private _onChange_DateStart(): void {
        this._isFocused = true;
        this._serializeRequestData();
    }

    private _onChange_DateEnd(): void {
        this._isFocused = true;
        this._serializeRequestData();
    }

    private _onChange_InputKeyword(): void {
        this._isFocused = true;
        this._serializeRequestData();
    }
    private _onEnter_InputKeyword(): void {
        this._isFocused = true;
        this._serializeRequestData(10);
    }

    
    private _setActiveFiltersAttr(activeFilters: Array<string>): void {
        this.setup(activeFilters, this.calendarID, this.resourceIDs);
    }

    setup(activeFilterIDs: Array<string>, calendarId: string, resourceIDs: Array<string>,) {
        this.activeFilterIDs = activeFilterIDs ? lang.clone(activeFilterIDs) : [];
        this.calendarID = calendarId;
        this.resourceIDs = resourceIDs ? lang.clone(resourceIDs) : []
    }

   
    private _onClick_clearDateStart(): void {
        this.inputDateStart.setValue(null);
    }

    private _onClick_clearDateEnd(): void {
        this.inputDateStart.setValue(null);
    }

    private requestData: WebcalendarTypes.RequestData = null;

    private _lastLoadedRequest: string = null;

    private _serializeRequestData(requestDelay?: number) {

        if (!this.calendarID) return;


        this.requestData = {
            _version: 202506,
            cid: this.calendarID,
            //steps: 0,
            start: this.inputDateStart.getValue(),
            end: this.inputDateEnd.getValue(),
            filters: this.activeFilterIDs,
            mode: "search",
            viewBehaviour: "list",
            viewMode: WebcalendarTypes.WebCalendar_ViewModes.listView,
            viewType: WebcalendarTypes.WebCalendar_ViewTypes.list,
            keyword: this.inputKeyword.getValue(),
            resources: this.resourceIDs
        };

        if (this.requestTimeoutHandle) clearTimeout(this.requestTimeoutHandle);
        if (this._requestHandle) {
            this._requestHandle.cancel();
            this._requestHandle = null;
        }

        if (JSON.stringify(this.requestData) != this._lastLoadedRequest) {
            if (this._isFocused) {
                this.requestTimeoutHandle = setTimeout(lang.hitch(this, this._loadResults), requestDelay ? requestDelay : 500);
            }
        }
    }

    private requestTimeoutHandle: any = null;
    private _requestHandle: dojo.request.Promise<any> = null;
    private _loadResults() {
        if (this._requestHandle) {
            this._requestHandle.cancel();
            this._requestHandle = null;
        }

        if (!this.requestData) return;

        this._isFocused = false;

        this.StandbyStart();

        this._requestHandle = this.RequestManager.callfunction(
            "Webtool_API_Webcalendar__GetSearchPanelResults",
            this.requestData,
            lang.hitch(this, this._onLoadResultsResults),
            lang.hitch(this, this._onLoadResultsError)

        );
    }

    private _onLoadResultsResults(result: WebcalendarTypes.FilterResponse) {
        this.displayMessage(result.message);

        this.hideNode(this.resultContainer);

        this.resultItems = result.items;

        this.StandbyStop();

        this.buildResultlist();
    }

    private resultItems: Array<WebcalendarTypes.WebCalendarItemData_Default> = null;
    private buildResultlist() {

        let container = this.UiModder.domConstruct.create("div", { id: "resultItemsContainer", className: "sectionCard" });

        for (let item of this.resultItems) {
            let itemContainer = this.UiModder.domConstruct.create("div", { className: "item" }, container);
            itemContainer.innerHTML = item.id;
        }
        //this.UiModder.domConstruct.place(container, this.resultContainer, "only");
        this.hideNode(this.resultContainer, false);

        let float = new FloatingContainer();
        float.open(document.getElementById("menuContainer"));
    }

    private displayMessage(message: string) {
        if (!message) {
            this.hideNode(this.messageContainer);
            return;
        }

        else {
            this.txtMessage.innerHTML = message;
            this.hideNode(this.messageContainer, false);
        }
    }

    private _onLoadResultsError(error: more.requestErrorMessage) {
        this.StandbyStop();
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        ///
        this.RequestManager.handleAs = "jsonWithDate";
        this.useStandbyManager = true;

    }

    startup(): void {
        super.startup.apply(this, arguments as any);


        this._setControlDateLimits();

    }


}

export default mdsWidget(MainPropertiesSearchPanel);